import React, { Component } from "react";

import faArrow from "@fortawesome/fontawesome-free-solid/faArrowLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import imgCalendar from "../../../img/svg/calendar-big.svg";
import imgArrowNext from "../../../img/svg/fleche-droit.svg";
import "react-datepicker/dist/react-datepicker.css";
import ButtonPicker from "../../user/ButtonPicker";
import { registerLocale } from "react-datepicker";
import { splitStrLang } from "./../../../utils/utils";
import { Localized } from "fluent-react/compat";
import DatePicker from "react-datepicker";
import { motion } from "framer-motion";
import fr from "date-fns/locale/fr";
import es from "date-fns/locale/es";

class ClosingDate extends Component {
  constructor(props) {
    super(props);
    const hasCloseDate = Object.keys(props.closingDate).length;
    this.state = {
      displayDateRange: hasCloseDate,
      startDate: hasCloseDate
        ? new Date(props.closingDate.date_start)
        : new Date(),
      endDate: hasCloseDate ? new Date(props.closingDate.date_end) : new Date(),
      action: hasCloseDate ? "update" : "add",
      langsAvailable: [
        { lang: fr, key: "fr" },
        { lang: es, key: "es" },
      ],
      currentLang: { lang: fr, key: "fr" },
    };
    this.setLangToDatePicker = this.setLangToDatePicker.bind(this);
    this.displayDateRange = this.displayDateRange.bind(this);
    this.removeData = this.removeData.bind(this);
    this.submitData = this.submitData.bind(this);
    this.setStart = this.setStart.bind(this);
    this.setEnd = this.setEnd.bind(this);
  }

  componentDidMount() {
    this.setLangToDatePicker();
  }

  setLangToDatePicker() {
    const navLang = splitStrLang(window.navigator.language);
    const hasLang = this.state.langsAvailable.find(
      (item) => item.key === navLang
    );
    return hasLang && hasLang.key !== this.state.currentLang.key
      ? this.setState({ currentLang: hasLang })
      : null;
  }

  displayDateRange() {
    this.setState({ displayDateRange: true });
  }

  removeData(e) {
    this.props.submitDateClosed({}, "remove");
  }

  submitData(e) {
    const { startDate, endDate, action } = this.state;
    const checkAction = action;
    const dateClosed = {
      date_start: startDate,
      date_end: endDate,
    };
    this.props.submitDateClosed(dateClosed, checkAction);
  }

  setStart(date) {
    this.setState({ startDate: date });
  }

  setEnd(date) {
    this.setState({ endDate: date });
  }
  render() {
    const {
      displayDateRange,
      currentLang,
      startDate,
      endDate,
      action,
    } = this.state;
    return (
      <React.Fragment>
        <div className="container-title-closing-date">
          <span
            className="button-back"
            onClick={this.props.updateDisplayCloseDates}
          >
            <FontAwesomeIcon icon={faArrow} />
          </span>
          <h3>
            <Localized id="tr-admin-days-closed" />
          </h3>
        </div>
        <div className="container-calendar">
          <div
            className={`container-text-closing-date ${
              action === "add" ? "" : "disabled-text-closing-date"
            }`}
          >
            <motion.span
              className="button-action"
              whileTap={{
                scale: action === "add" ? 0.9 : 1,
              }}
              onClick={
                action === "add" ? (e) => this.displayDateRange(e) : null
              }
            >
              +
            </motion.span>{" "}
            <p>
              <Localized id="tr-create-range-closed" />
            </p>
          </div>
          {displayDateRange ? (
            <React.Fragment>
              <div className="container-date-picker">
                <img src={imgCalendar} className="calendar" alt="calendar" />
                <div className="container-picker">
                  <p>
                    <Localized id="tr-admin-hour-start" />
                  </p>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={startDate}
                    onChange={this.setStart}
                    locale={currentLang.lang}
                    minDate={new Date()}
                    startDate={startDate}
                    endDate={endDate}
                    className="input-date-picker"
                  />
                </div>
                <img src={imgArrowNext} className="arrow" alt="arrow" />
                <div className="container-picker">
                  <p>
                    <Localized id="tr-admin-hour-end" />
                  </p>
                  <DatePicker
                    dateFormat="dd/MM/yyyy"
                    selected={endDate}
                    onChange={this.setEnd}
                    locale={currentLang.lang}
                    endDate={endDate}
                    minDate={startDate}
                    className="input-date-picker"
                  />
                </div>
                <ButtonPicker
                  submitData={this.submitData}
                  removeData={this.removeData}
                />
              </div>
            </React.Fragment>
          ) : (
            <h3 className="range-closed">
              <Localized id="tr-range-closed" />
            </h3>
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default ClosingDate;
